import * as React from 'react'
import { useSelector } from 'react-redux'
import { Module } from '../../api'
import store from '../../store'
import { addLabelToModule, removeLabelFromModule } from '../../store/actions/modules'
import { ModuleID, ModuleLabel } from '../../store/types'
import { createIdFromName } from '../../helpers'
import ModuleLabelComp from '../../components/ModuleLabel'
import ModuleLabelsList from '../../components/ModuleLabelsList'
import Icon from '../../components/ui/Icon'
import Tooltip from '../ui/Tooltip'

import './index.css'

interface ModuleLabelsProps {
  module: Module | ModuleID
  onModuleLabelClick?: (label: ModuleLabel) => void
}

const ModuleLabels = ({
  module,
  onModuleLabelClick,
}: ModuleLabelsProps) => {
  const [editLabels, setEditLabels] = React.useState(false)
  const { labels, modulesWithLabels } = useSelector(state => ({
    labels: state.modules.labels,
    modulesWithLabels: state.modules.modulesWithLabels,
  }))

  const moduleId = typeof module === 'string' ? module : module.id
  const moduleLabels = (modulesWithLabels[moduleId] || []).map(lId => labels[lId])

  // Triggered by click or from child component.
  const toggleEditLabel = (ev: React.MouseEvent | undefined) => {
    if (ev) {
      ev.preventDefault()
    }
    setEditLabels(!editLabels)
  }

  const onLabelClick = (label: ModuleLabel) => {
    if (moduleLabels.find(ml => ml.id === label.id)) {
      removeLabel(label)
    } else {
      addLabel(label)
    }
  }

  const addLabel = (label: ModuleLabel) => {
    store.dispatch(addLabelToModule(moduleId, label))
  }

  const removeLabel = (label: ModuleLabel) => {
    store.dispatch(removeLabelFromModule(moduleId, label.id))
  }

  const onLabelCreate = (labelName: string) => {
    store.dispatch(addLabelToModule(moduleId, createIdFromName(labelName)))
  }

  return (
    <div className="module-labels">
      {
        moduleLabels.length
          ? <div className="module-labels__labels">
            {
              moduleLabels.map(label => (
                <ModuleLabelComp
                  key={label.id}
                  label={label}
                  onClick={onModuleLabelClick}
                />
              ))
            }
          </div>
          : null
      }
      <Tooltip l10nId="module-labels-list-edit-labels">
        <span
          className="module-labels__settings"
          onClick={toggleEditLabel}
        >
          <Icon size="medium" name="label"/>
        </span>
      </Tooltip>
      {
        editLabels
          ?
          <ModuleLabelsList
            active={moduleLabels}
            title="module-labels-selector-title"
            onLabelClick={onLabelClick}
            onClose={toggleEditLabel as () => void}
            onLabelCreate={onLabelCreate}
          />
          : null
      }
    </div>
  )
}

export default ModuleLabels
